'use client'

import { useEffect, useState } from 'react'

interface MediaQueries {
	isMobile: boolean
	isSmDesktop: boolean
	isTablet: boolean
	isDesktop: boolean
	isBigDesktop: boolean
}

const queries = [
	'(max-width: 576px)',
	'(min-width: 577px) and (max-width: 768px)',
	'(min-width: 577px) and (max-width: 1199px)',
	'(min-width: 1200px)',
	'(min-width: 2160px)'
]

export const useMediaQueries = (): MediaQueries => {
	const isWindowExist = typeof window !== 'undefined'
	const mediaQueryList = isWindowExist ? queries.map(query => window.matchMedia(query)) : []
	const getValues = isWindowExist ? mediaQueryList.map(query => query.matches) : []

	const [values, setValues] = useState([false, false, false, false, false])

	useEffect(() => {
		if (!isWindowExist) return
		setValues(getValues)
	}, [isWindowExist])

	useEffect(() => {
		if (!isWindowExist) return
		const handler = () => {
			setValues(getValues)
		}

		mediaQueryList.forEach(() => window.addEventListener('resize', handler))

		return () => mediaQueryList.forEach(() => window.removeEventListener('resize', handler))
	}, [getValues, mediaQueryList, isWindowExist])

	return {
		isMobile: values[0],
		isSmDesktop: values[1],
		isTablet: values[2],
		isDesktop: values[3],
		isBigDesktop: values[4]
	}
}
